import {SocialAdType} from 'common/src/modules/externalAds/externalAds.types';

export enum OutputType {
  Regular = 1,
  Fallback,
  Last,
  PartialSuccess,
}

export interface ServerNode {
  type: NodeType;
  id: number;
  x?: number;
  y?: number;
  outputs: NodeOutputData[];
  name?: string;
  description?: string;
  nextOutputId?: number;
  adType?: SocialAdType;
}

export interface MapNode extends ServerNode {
  inputs: NodeInputData[];
}

export type Nodes = Record<number, MapNode>;

export interface ReceivedContent {
  receivedContent: number[];
  ReceivedProductType: number;
}

export interface NodeOutputData {
  nodeId: number;
  node?: MapNode | null;
  receivedContent?: ReceivedContent;
  id: number;
  type?: OutputType;
  name?: string | null;
}

export interface NodeInputData {
  node: MapNode | null;
  outputIdx: number;
}

export interface DisconnectedNodeInputData {
  nodeId: number | null;
  outputIdx: number;
}

export interface DisconnectedNodeOutputData extends Omit<NodeOutputData, 'node'> {
  referencedNodeId?: number | null;
}

export interface DisconnectedMapNode extends Omit<ServerNode, 'outputs'> {
  inputs: DisconnectedNodeInputData[];
  outputs: DisconnectedNodeOutputData[];
}

export type DisconnectedNodes = Record<number, DisconnectedMapNode>;

export enum NodeType {
  VIDEO_CAMPAIGN = -1,
  CAMPAIGN = 0,
  CONDITION = 10,
  COMPOUND_CONDITION = 11,
  WEIGHTED = 20,
  DISTRIBUTION = 25,
  PRODUCTS = 30,
  STORE = 40,
  GENERAL_OPTIMIZATION = 70,
  SCHEDULE = 80,
  SEQUENCE = 90,
  CREATIVE = 100,
  NATIVE_CREATIVE = 110,
  SOCIAL_FACEBOOK_AD_CREATIVE = 121,
  SOCIAL_TIKTOK_AD_CREATIVE = 122,
  SOCIAL_YOUTUBE_AD_CREATIVE = 123,
  SOCIAL_SNAPCHAT_AD_CREATIVE = 124,
  SOCIAL_YOUTUBE_DV360_AD_CREATIVE = 125,
  SOCIAL_LINKEDIN_AD_CREATIVE = 126,
  FACEBOOK_CAROUSEL_CREATIVE = 130,
  CONCEPT_CREATIVE = 140,
  FACEBOOK_DPA_CREATIVE = 150,
  FACEBOOK_DPA_CAROUSEL_CREATIVE = 160,
  CONTENT_FEED = 170,
  SOCIAL_MOCK_SOCIAL_AD_CREATIVE = 121,
}
